module.exports = function() {
  return new Worker(__webpack_public_path__ + "a03b76f4c00ac0a7de61.worker.js");
};